import React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { submit, isInvalid } from "redux-form";
import { WithStyles, withStyles, Grid } from "material-ui";

import {
    SetHeader,
    ShowLogo,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
} from "../../ducks/common";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import {
    SetActionButtonAndShow,
    SetShowActionButton,
    ResetActionButtonClicked,
    actionButtonClicked,
    SetActionButtonDisabled,
    actionButtonDisabled,
} from "../../ducks/actionbutton";
import {
    getAllAccounts,
    getSelectedAccount,
    getAllAccountsData,
    Accounts,
    saveWithdrawalRequestForm,
} from "../../ducks/account";

import WithdrawalRequestForm, {
    IWithdrawalRequestFormData,
} from "./components/withdrawalRequestForm";
import { numericCommaStringToDecimal } from "../../util/numericTransformation";

const styles = {} as React.CSSProperties;

interface IWithdrawalRequestPageProps
    extends RouteComponentProps<{ id: number }> {}

interface IWithdrawalRequestPageReduxProps {
    actionButtonClicked: boolean;
    accountsData: Accounts;
    selectedAccount: string;
    actionButtonDisabled: boolean;
    invalid: boolean;
}

interface IWithdrawalRequestPageDispatchProps {
    getAccountsData: () => void;
    submitWithdrawalRequestForm: () => void;
    saveWithdrawalRequestFormData: (data: IWithdrawalRequestFormData) => void;
    setHeaderValue: (header: string) => void;
    showLogo: (show: boolean) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    setShowActionButton: (show: boolean) => void;
    setActionButton: (text: string) => void;
    resetActionButtonClick: () => void;
    disableActionButton: (disabled: boolean) => void;
}

interface IWithdrawalRequestPageState {}

type WithdrawalRequestPageConnectedProps = IWithdrawalRequestPageProps &
    IWithdrawalRequestPageReduxProps &
    IWithdrawalRequestPageDispatchProps;

type WithdrawalRequestPagePropsWithStyles = WithdrawalRequestPageConnectedProps &
    WithStyles<"">;

class WithdrawalRequestPage extends React.Component<
    WithdrawalRequestPagePropsWithStyles,
    IWithdrawalRequestPageState
> {
    componentDidMount() {
        this.props.setHeaderValue("Nostopyyntö");
        this.props.showLogo(false);
        this.props.setBackButton("");
        this.props.setActionButton("Lähetä");
        this.props.getAccountsData();
    }

    componentWillUnmount() {
        this.props.showLogo(true);
        this.props.hideBackButton();
        this.props.setShowActionButton(false);
    }

    componentWillReceiveProps(nextProps: WithdrawalRequestPagePropsWithStyles) {
        if (this.props.invalid !== nextProps.invalid) {
            if (nextProps.invalid && !nextProps.actionButtonDisabled) {
                this.props.disableActionButton(true);
            } else if (!nextProps.invalid && nextProps.actionButtonDisabled) {
                this.props.disableActionButton(false);
            }
        }

        if (nextProps.actionButtonClicked === true) {
            this.props.submitWithdrawalRequestForm();
        }
    }

    save = async (data: IWithdrawalRequestFormData) => {
        try {
            data.id = Number(data.accountNumber);
            data.amount = numericCommaStringToDecimal(data.amount);
            data.accountNumber = this.props.accountsData[
                Number(data.id)
            ].accountNumber;

            await this.props.saveWithdrawalRequestFormData(data);
            this.props.resetActionButtonClick();
            this.props.history.push(`/account/request/withdrawalsent`);
        } catch (error) {
            throw error;
        } finally {
            this.props.resetActionButtonClick();
        }
    };

    render() {
        const { classes } = this.props;
        const accounts = Object.keys(this.props.accountsData)
            .filter((key) => {
                const acc = this.props.accountsData[key];
                return acc.canWithdraw;
            })
            .map((key) => {
                const acc = this.props.accountsData[key];
                const label = acc.accountName
                    ? `${acc.accountName} - ${acc.accountNumber}`
                    : `${acc.accountNumber}`;
                return { label: label, value: key };
            });

        return (
            <div className="page-container">
                <WithdrawalRequestForm
                    allAccountsList={accounts}
                    selectedAccountData={
                        this.props.accountsData[this.props.selectedAccount]
                    }
                    form="withdrawalRequestForm"
                    onSubmit={this.save}
                />
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: WithdrawalRequestPagePropsWithStyles
): IWithdrawalRequestPageReduxProps => {
    const disabled = actionButtonDisabled(state);
    return {
        actionButtonClicked: actionButtonClicked(state),
        accountsData: getAllAccountsData(state),
        selectedAccount: getSelectedAccount(state, "withdrawalRequestForm"),
        actionButtonDisabled: disabled,
        invalid: isInvalid("withdrawalRequestForm")(state),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IWithdrawalRequestPageDispatchProps => {
    return {
        getAccountsData: () => {
            dispatch(getAllAccounts());
        },
        submitWithdrawalRequestForm: async () => {
            await dispatch(submit("withdrawalRequestForm"));
        },
        saveWithdrawalRequestFormData: async (
            data: IWithdrawalRequestFormData
        ) => {
            await dispatch(saveWithdrawalRequestForm(data));
        },
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        showLogo: (show: boolean) => {
            return dispatch(ShowLogo(show));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        setShowActionButton: (show: boolean) => {
            dispatch(SetShowActionButton(show));
        },
        setActionButton: (text: string) => {
            dispatch(SetActionButtonAndShow({ text }));
        },
        resetActionButtonClick: () => {
            dispatch(ResetActionButtonClicked());
        },
        disableActionButton: (disabled: boolean) => {
            dispatch(SetActionButtonDisabled(disabled));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(WithdrawalRequestPage));



// WEBPACK FOOTER //
// ./src/views/account/WithdrawalRequestPage.tsx